// utils/bannerHeight.ts
export const bannerHeight = () => {
    return "440px";
};
